import axios from "@/axios/axios";
import { directStatus } from "@/data/constances";

export default {
  namespaced: true,
  state: {
    selectedNapMatching: {},
    matchingList: [],
  },
  actions: {
    loadReceivedMatching({ commit }, params) {
      let apiUrl = "";
      if (params?.status) {
        apiUrl = "/api/matching/direct/getByRequestedAndStatus";
      } else {
        apiUrl = "/api/matching/direct/getByRequested";
      }

      axios
        .get(apiUrl, { params })
        .then((res) => {
          if (res.status == 200) {
            let list = res.data.sort(
              (a, b) =>
                new Date(b.submittedTime).getTime() -
                new Date(a.submittedTime).getTime()
            );
            commit("setMatchingList", list);
          }
        })
        .catch((e) => {
          console.error(e);
        });
    },
    loadSentMatching({ commit }, params) {
      let listApi = [];
      // if (params?.status) {
      //   listApi.push({ url: "/api/matching/direct/getByRequesterAndStatus", method: 'GET', params: params })
      //   if (params.status != directStatus.REJECT)
      //     listApi.push({ url: "/api/matching/nap/getByRequesterAndStatus", method: 'GET', params: params })

      // } else {
      //   listApi.push({ url: "/api/matching/direct/getByRequester", method: 'GET', params: params });
      //   if (params.status != directStatus.REJECT)
      //     listApi.push({ url: "/api/matching/nap/getByRequester", method: 'GET', params: params });
      // }

      listApi.push({
        url: "/api/matching/direct/getByRequesterAndStatus",
        method: "GET",
        params: params,
      });
      if (params.status != directStatus.REJECT)
        listApi.push({
          url: "/api/matching/nap/getByRequesterAndStatus",
          method: "GET",
          params: params,
        });

      console.log(listApi);

      Promise.all(listApi.map((api) => axios(api))).then((values) => {
        let list = [];
        if (values[0]?.status == 200) {
          let tmp = values[0].data.map((item) => ({ ...item, isNap: false }));
          list.push(...tmp);
        }
        if (values[1]?.status == 200) {
          let tmp = values[1].data.map((item) => ({ ...item, isNap: true }));
          list.push(...tmp);
        }

        list = list.sort(
          (a, b) =>
            new Date(b.submittedTime).getTime() -
            new Date(a.submittedTime).getTime()
        );

        commit("setMatchingList", list);
      });
    },
    directGetByRequester(context, params) {
      const searchParams = new URLSearchParams(params);
      return axios
        .get("/api/matching/direct/getByRequester?" + searchParams.toString())
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    napGetByRequester(context, params) {
      const searchParams = new URLSearchParams(params);
      return axios
        .get("/api/matching/nap/getByRequester?" + searchParams.toString())
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response.data);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    napDetail({ commit }, idx) {
      return axios
        .get("/api/matching/nap/get", { params: { idx } })
        .then((response) => {
          if (response.status == 200) {
            commit("setSelectedNapMatching", response.data);
            return Promise.resolve(response.data);
          } else {
            commit("setSelectedNapMatching", {});
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    napUpdate(_, params) {
      const searchParams = new URLSearchParams(params);
      return axios
        .post("/api/matching/nap/update?" + searchParams.toString())
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
    napDelete(context, params) {
      const searchParams = new URLSearchParams(params);
      return axios
        .delete("/api/matching/nap/delete?" + searchParams.toString())
        .then((response) => {
          if (response.status == 200) {
            return Promise.resolve(response);
          }

          return Promise.reject(response.message);
        })
        .catch((error) => {
          console.log(error);
          return Promise.reject(error);
        });
    },
  },
  mutations: {
    setSelectedNapMatching(state, payload) {
      state.selectedNapMatching = payload;
    },
    setMatchingList(state, payload) {
      state.matchingList = payload;
    },
    replaceMatchingItem(state, payload) {
      state.matchingList = state.matchingList.map((item) =>
        item.idx === payload.idx ? payload : item
      );
    },
    removeMatchingItem(state, payload) {
      state.matchingList = state.matchingList.filter(
        (item) => item.idx !== payload.idx
      );
    },
  },
};
